import React from "react";
import { Card } from "antd";
import styles from "./ContentCard.module.css";
export const ContentCard = (props) => {
  const { filter, children, add } = props;
  return (
    <div className={styles.ContentCardContainer}>
      {add ? <div className={styles.AddButton}>{add}</div> : null}
      <Card className={styles.ContentCard}>
        <div>{filter}</div>
        <div>{children}</div>
      </Card>
    </div>
  );
};
